module.exports = __webpack_public_path__ + "img/img_3.c16a8aec.jpg";